import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './index.css';
import { DashBoardTitle } from '../../Title';
import Edit from '../../../images/Edit Web.png';
import { Col, Container, Row, Table } from 'reactstrap';
import {
  getDealerwithStatus,
  deleteDealer as deleteDealerRecord,
} from '../../../constants/apiCalls';
import Pagination from '../../Pagination/Pagination';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import deleteImg from '../../../assets/img/delete.svg';
import swal from 'sweetalert';
import ModalService from '../../../services/ModalService';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { UserFilters } from '../../Filters';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { AddUserButton } from '../../CommonComponents';
import { messages } from '../../../utils/constant-messages';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import ThemeOptions from '../../../Layout/ThemeOptions';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

export function PipelineTable() {
  let userInfo = Storage.getUserInfoDetail();
  let userId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';
  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();

  const { permissionArr } = useSelector((state) => state.UserGetReducer);
  const localPermission = permissionArr;

  useEffect(() => {
    if (!localPermission.includes(Permissions.PIPELINE)) {
      navigate('/');
    }
  }, [...localPermission]);

  let pageNo = useMemo(() => Storage.getPipelinePage(), [
    Storage.getPipelinePage(),
  ]);

  const [isLoading, setIsloading] = useState(false);
  const [dealerData, setDealerData] = useState([]);

  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);
  const [object, setObject] = useState('');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const location = useLocation();
  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    [],
  );

  useEffect(() => { }, [userData]);

  const getDealerData = useCallback(
    (obj, page, pageSize) => {
      setIsloading(true);
      setObject(obj);
      let payload = {
        q: obj.searchQuery || '',
        pagesize: pageSize,
        page: page || 1,
        type: 'pipeline',
        pipeline_status: obj.statusId || null,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        adminOnly: false,
        manageDealer: false,
        application_upload: false,
        is_download: false,
      };
      getDealerwithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setDealerData(data.data);
          let count = data.total_count;
          setCount(count);
          let totalPages = Math.ceil(count / pageSize);
          setTotalPages(totalPages);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize],
  );

  const handleExcelSheet = useCallback(
    (obj, page, pageSize) => {
      let payload = {
        q: obj.searchQuery || '',
        pagesize: 100000,
        page: page || 1,
        type: 'pipeline',
        pipeline_status: obj.statusId || null,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        adminOnly: false,
        manageDealer: false,
        application_upload: false,
        is_download: true,
      };
      getDealerwithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          window.open(data.file, '_blank');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize],
  );

  const handleAddUser = () => {
    Storage.setBreadcrumbsrRecord([
      {
        title: 'Pipeline',
        url:
          location.pathname.split(/(\d+)/)[0] +
          location.pathname.split(/(\d+)/)[1],
      },
    ]);
    navigate(`/pages/new-dealer`);
    Storage.setPipelinePage(1);
    setPage(1);
  };
  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setPipelinePage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize],
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize],
  );

  const deleteDealer = (id) => {
    swal({
      title: 'Delete Dealer',
      text: 'Are you sure, you want to delete?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((isConfirm) => {
      if (isConfirm) {
        setIsloading(true);
        deleteDealerRecord(
          (res) => {
            const { success, message, error } = res;
            if (success === true) {
              ModalService.openAlert('', message, 'success');
              setIsloading(false);
              getDealerData(object, page, pageSize);
            } else if (success === false || success === 'undefined') {
              ModalService.openAlert(
                '',
                handleErrorMessage(error[0].message),
                'error',
              );
              setIsloading(false);
            }
            setIsloading(false);
          },
          { id: id },
        );
      }
    });
  };

  const setBreadcrumbsRecord = () => {
    Storage.setBreadcrumbsrRecord([
      {
        title: 'Pipeline',
        url:
          location.pathname.split(/(\d+)/)[0] +
          location.pathname.split(/(\d+)/)[1],
      },
    ]);
  };

  const editData = (id) => {
    setBreadcrumbsRecord();
    navigate({
      // pathname: `/pages/basic-business-info/${id}`
      pathname: `/pages/new-dealer/${id}`,
    });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="pipelineTable">
              {isLoading && <CustomSpinner />}
              <div className="pageWrapper">
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className="pageheader">
                        <DashBoardTitle dashBorardName="New Dealer Pipeline" />
                        <BreadCrumbBackButton />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title="Pipeline" />
                    </Col>
                    <Col xs={12}>
                      {roleName === Roles.TM_NAME || roleName === Roles.SH_NAME ? (
                        <div className="addDealerBtnBlock">
                          <AddUserButton
                            onClick={handleAddUser}
                            name="Add New Dealer"
                          />
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                  </Row>
                  {dealerData && dealerData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className="table-responsive dealerTable">
                          <Table bordered className="table text-center">
                            <thead>
                              <tr>
                                <th>Pending Since</th>
                                <th>Application Date</th>
                                <th>Form Number</th>
                                <th>Dealership Name</th>
                                <th>Owner Name</th>
                                <th>Mobile</th>
                                {roleName === Roles.BH_NAME && <th>NH</th>}
                                {(roleName === Roles.NH_NAME ||
                                  roleName === Roles.BH_NAME) && <th>SH</th>}
                                <th>TM</th>
                                {roleName !== Roles.TM_NAME && <th>State</th>}
                                <th>Territory</th>
                                <th>Status Of Application</th>
                                {roleName !== Roles.BH_NAME && <th>Action</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {dealerData.map((elem, index) => {
                                const {
                                  application_date,
                                  id,
                                  business_name,
                                  primary_contact_name,
                                  primary_contact_mobile,
                                  nh,
                                  sh,
                                  th,
                                  territory,
                                  pending_status,
                                  days,
                                  state,
                                  created_by,
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>{`${days} Days`}</td>
                                    <td>
                                      {DateService.localDateOnly(application_date) ||
                                        'N/A'}
                                    </td>
                                    <td>{id}</td>
                                    <td>
                                      <span>{business_name}</span>
                                    </td>
                                    <td>{primary_contact_name}</td>
                                    <td>{primary_contact_mobile}</td>
                                    {roleName === Roles.BH_NAME && <td>{nh}</td>}
                                    {(roleName === Roles.NH_NAME ||
                                      roleName === Roles.BH_NAME) && <td>{sh}</td>}
                                    <td>{th}</td>
                                    {roleName !== Roles.TM_NAME && <td>{state}</td>}
                                    <td>{territory}</td>
                                    <td>
                                      <span
                                        className={`pendingStatus 
                              ${pending_status === 'Pending with TM' &&
                                            roleName === Roles.TM_NAME
                                            ? 'green'
                                            : ''
                                          } 
                              ${pending_status === 'Pending with SH' &&
                                            roleName === Roles.SH_NAME
                                            ? 'red'
                                            : ''
                                          } 
                              ${pending_status === 'Pending with NH' &&
                                            roleName === Roles.NH_NAME
                                            ? 'blue'
                                            : ''
                                          } 
                              `}
                                      >
                                        {pending_status}
                                      </span>
                                    </td>
                                    {roleName !== Roles.BH_NAME && (
                                      <td>
                                        {roleName === Roles.NH_NAME &&
                                          pending_status === 'Pending with NH' && (
                                            <div className="iconBlock">
                                              <img
                                                src={Edit}
                                                alt="img"
                                                className="iconImg"
                                                onClick={() =>
                                                  navigate(
                                                    `/pages/approve-application-by-sh/${id}`,
                                                  )
                                                }
                                              />
                                            </div>
                                          )}
                                        {roleName === Roles.SH_NAME &&
                                          pending_status === 'Pending with SH' && (
                                            <div className="iconBlock">
                                              <img
                                                src={Edit}
                                                alt="img"
                                                className="iconImg"
                                                onClick={() => {
                                                  setBreadcrumbsRecord();
                                                  if (created_by === userId) {
                                                    navigate(
                                                      `/pages/new-dealer/${id}`,
                                                    );
                                                  } else {
                                                    navigate(
                                                      `/pages/approve-application-by-sh/${id}`,
                                                    );
                                                  }
                                                }}
                                              />
                                            </div>
                                          )}
                                        {roleName === Roles.TM_NAME &&
                                          pending_status === 'Pending with TM' && (
                                            <div className="iconBlock">
                                              {pending_status === 'Pending with TM' && (
                                                <img
                                                  src={Edit}
                                                  alt="editIcon"
                                                  className="iconImg"
                                                  onClick={() => editData(id)}
                                                />
                                              )}
                                              <img
                                                className="cursor-pointer iconImg"
                                                alt="deleteIcon"
                                                onClick={() => deleteDealer(id)}
                                                src={deleteImg}
                                              />
                                            </div>
                                          )}
                                      </td>
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="paginationWrapper">
                          <span className="page-select-title">Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className="form-control rows-per-page-select"
                            name="pageSize"
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key="5" value="5">
                              5 Rows
                            </option>
                            <option key="10" value="10">
                              10 Rows
                            </option>
                            <option key="15" value="15">
                              15 Rows
                            </option>
                            <option key="20" value="25">
                              25 Rows
                            </option>
                            <option key="25" value="30">
                              30 Rows
                            </option>
                            <option key="30" value="50">
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className="pageList">
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>{messages.COMMON.NO_RECORD_MATCH}</Col>
                    </Row>
                  )}
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
